import { render, staticRenderFns } from "./lineamientos.vue?vue&type=template&id=26a5c778&scoped=true"
import script from "./lineamientos.vue?vue&type=script&lang=js"
export * from "./lineamientos.vue?vue&type=script&lang=js"
import style0 from "./lineamientos.vue?vue&type=style&index=0&id=26a5c778&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26a5c778",
  null
  
)

export default component.exports